import Vue from 'vue';
import store from './../../store';

export default (name) => {
  store.dispatch('logout');
  store.dispatch('resetAccount');
  mixpanel.track("web.logout");
  if(name != 'bookings.invoice' || name != 'bookings.invoice.edit') {
    localStorage.clear();
    Vue.router.push({
      name: 'login.index',
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/services/auth/logout.js